"use client";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import ui6 from "@/assest/ui6.png";
import { IHeroRecord } from "../interface/IHeroSection";

const PackageHero = ({
  breadcrumbData,
}: {
  breadcrumbData?: IHeroRecord[];
}) => {
  const [index, setIndex] = useState(0);
  const sliderImages = breadcrumbData?.[0]?.image || [];

  // const nextSlide = () => {
  //   if (index < exclusiveHolidayData.length - 1) setIndex(index + 1);
  //   else setIndex(0);
  // };
  // const prevSlide = () => {
  //   if (index > 0) setIndex(index - 1);
  //   else setIndex(exclusiveHolidayData.length - 1);
  // };
  // const prevImage =
  //   exclusiveHolidayData[
  //     (index - 2 + exclusiveHolidayData.length) % exclusiveHolidayData.length
  //   ];
  const prevImage =
    sliderImages[(index - 2 + sliderImages.length) % sliderImages.length];
  const heroImageSrc = prevImage?.image || "/assest/aboutHero.png";

  return (
    <div>
      <figure className="relative min-h-[85vh] w-full mb-16">
        <AnimatePresence>
          <motion.div
            key={prevImage?.id}
            initial={{ opacity: 0, x: "-100%" }}
            animate={{ opacity: 1, x: "0%" }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="absolute inset-0"
          >
            <Image
              src={heroImageSrc}
              alt="image"
              height={400}
              width={600}
              priority
              className="object-cover brightness-75 h-full w-full"
            />
          </motion.div>
        </AnimatePresence>
        <div className="absolute text-white md:top-[30%] top-[15%] flex md:flex-row flex-col justify-between w-full px-10 gap-10">
          <div className="md:w-1/2 pb-10 md:pb-0">
            <h2 className="typography-h2-light font-semibold bg-opacity-50">
              {breadcrumbData?.[0]?.title}
            </h2>
            <p
              className="typography-large-body-regular md:mr-20 line-clamp-3"
              dangerouslySetInnerHTML={{
                __html: breadcrumbData?.[0]?.description || "",
              }}
            ></p>
          </div>
          <div className="w-1/2">
            <div className="flex flex-row gap-10 my-[23rem] relative">
              <div className="relative flex-1">
                <p className="typography-sub-h1-regular ml-[45%]">
                  {/* {sliderImages[index]?.title} */}
                </p>
                {sliderImages.length > 1 && (
                  <>
                    <div className="absolute left-[40%] bottom-[50%] z-30 overflow-visible">
                      <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{
                          transform: `translateX(-${index * 285}px)`,
                        }}
                      >
                        {sliderImages.map((item: any, i: number) => {
                          const last = sliderImages.length;

                          const isCurrent = i === index;
                          const isAdjacent =
                            i === (index - 1 + last) % last ||
                            i === (index + 1) % last;

                          return (
                            <motion.div
                              key={item.id}
                              layout
                              onClick={() => setIndex(i)}
                              animate={
                                isCurrent
                                  ? {
                                      width: 260,
                                      height: 350,
                                      y: -50,
                                      scale: 1,
                                      x: 0,
                                      zIndex: 30,
                                      opacity: 1,
                                    }
                                  : isAdjacent
                                    ? {
                                        width: 260,
                                        height: 350,
                                        y: 0,
                                        scale: 0.95,
                                        x: 0,
                                        zIndex: 20,
                                        opacity: 1,
                                      }
                                    : {
                                        width: 260,
                                        height: 350,
                                        y: 0,
                                        x: 0,
                                        scale: 1,
                                        zIndex: 5,
                                        opacity: 0,
                                      }
                              }
                              transition={{
                                type: "spring",
                                stiffness: 100,
                                damping: 20,
                              }}
                              className={`relative rounded-3xl overflow-hidden shadow-[0_0_12px_0_#0000003D] cursor-pointer mr-6 ${
                                !isCurrent && !isAdjacent
                                  ? "pointer-events-none"
                                  : ""
                              }`}
                            >
                              <Image
                                src={item.image || "/assest/aboutHero.png"}
                                alt="image"
                                height={350}
                                width={260}
                                className="object-cover h-full w-full"
                              />
                            </motion.div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="absolute right-4 -top-96 flex gap-3 z-30">
                      <button
                        onClick={() =>
                          setIndex(
                            (prev) =>
                              (prev - 1 + sliderImages.length) %
                              sliderImages.length
                          )
                        }
                        className="bg-[#F2F2F2] text-grey-600 text-lg font-bold p-2 hover:px-3 rounded-full hover:bg-white transition"
                      >
                        <ArrowLeft />
                      </button>

                      <button
                        onClick={() =>
                          setIndex((prev) => (prev + 1) % sliderImages.length)
                        }
                        className="bg-[#F2F2F2] text-grey-600 text-lg font-bold p-2 hover:px-3 rounded-full hover:bg-white transition"
                      >
                        <ArrowRight />
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </figure>
      <Image
        src={ui6}
        alt=" "
        width={50}
        height={50}
        className="absolute w-23 h-30 left-[32%]"
      />
    </div>
  );
};

export default PackageHero;
